import { config } from 'configs'

const {
  fundraiser,
  program,
  service,
  volunteer,
  auction,
  rental,
  marketplace,
  organizationDashboard,
  organizationDetails,
  organizationSubscription,
  organizationPayment,
  organizationReport,
  organizationBusinessRequests,
  organizationB2BProgram,
  organizationCommunity,
} = config.components

const ComponentPermissionGroup = [
  {
    Component: fundraiser,
    Label: fundraiser,
    Description: 'This is for fundraiser',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: program,
    Label: program,
    Description: 'This is for program',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: service,
    Label: service,
    Description: 'This is for service',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: volunteer,
    Label: 'Volunteer Management',
    Description: 'This is for volunteer management',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: auction,
    Label: auction,
    Description: 'This is for auction',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: rental,
    Label: 'Facility Rentals',
    Description: 'This is for facility rentals',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: marketplace,
    Label: marketplace,
    Description: 'This is for marketplace',
    AllowEditor: true,
    AllowReader: true,
  },
]

const OrganizationPermissionGroup = [
  {
    Component: organizationDashboard,
    Label: 'Dashboard',
    Description: 'This is for organization dashboard',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationDetails,
    Label: 'Details',
    Description: 'This is for organization details',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationSubscription,
    Label: 'Subscription',
    Description: 'This is for organization subscription',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationPayment,
    Label: 'Payment',
    Description: 'This is for organization payments',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationReport,
    Label: 'Report',
    Description: 'This is for organization reports',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationBusinessRequests,
    Label: 'Business Requests',
    Description: 'This is for organization business requests',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationB2BProgram,
    Label: 'B2B Program',
    Description: 'This is for organization b2b program',
    AllowEditor: true,
    AllowReader: true,
  },
  {
    Component: organizationCommunity,
    Label: 'Community',
    Description: 'This is for organization community',
    AllowEditor: true,
    AllowReader: true,
  },
]

export { ComponentPermissionGroup, OrganizationPermissionGroup }
